// Add a new entry here for each release that has user-facing changes.
// The modal will appear once per user when the app version matches an entry they haven't seen.
// version must match the `version` field in package.json exactly.

export default [
    {
        version: 'v0.2.0',
        features: [
            'Table fill badge on each table shows seated/capacity (e.g. 2/6), turns green when full',
            'Custom table names — double-click any table header to rename it',
            'Drag unassigned participants from the sidebar directly to a table',
            'Press R to trigger random assignment from anywhere',
            'Participants are automatically locked after Randomly Assign All',
            'Search participants in the View All modal',
            'What\'s New modal — you\'re looking at it!',
        ],
        fixes: [
            'Dark mode fixes for participant dropdowns',
        ]
    },
    {
        version: 'v0.1.0',
        features: [
            'Initial release',
        ]
    }
]
